const updateActiveButtons = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedColors = urlParams.getAll('pf_opt_colour');
  const buttons = document.querySelectorAll('.boost-colour-checkbox_btn');

  if (!buttons.length) {
    return;
  }

  for (const button of buttons) {
    const filterKey = button.getAttribute('data-filter-key');
    button.classList.remove('boost-sd__filter-option-item-button--selected');

    if (filterKey && selectedColors.includes(filterKey)) {
      requestAnimationFrame(() => {
        button.classList.add('boost-sd__filter-option-item-button--selected');
      });
    }
  }
};

// Run once on load
window.addEventListener('load', updateActiveButtons);

// Set up a MutationObserver
const observeFilters = () => {
  const container = document.querySelector('#filters-container') || document.body;

  if (!container) {
    console.error('[observeFilters] No container found for MutationObserver.');
    return;
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'childList') {
        updateActiveButtons();
        break;
      }
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
};

window.addEventListener('load', observeFilters);

// boost color swatch checkbox ends here 

// Patch history methods to update buttons on navigation
const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

history.pushState = function (...args) {
  originalPushState.apply(this, args);
  setTimeout(updateActiveButtons, 1000);
};
history.replaceState = function (...args) {
  originalReplaceState.apply(this, args);
  setTimeout(updateActiveButtons, 1000);
};

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {


    // Handle boost recommendation section
    const boostSDRecommendation = document.querySelector('.boost-sd__recommendation');
    if (boostSDRecommendation) {
      observer.disconnect();

      const buttonContainer = document.querySelector('.boost__view-all-button');
      const boostSliderContainer = boostSDRecommendation.querySelector('.boost-sd__slider-container .slick-dots');
      const pageWidthSection = document.querySelector('.shopify-section:has(.boost-sd__recommendation) > .page-width');

      if (boostSliderContainer) {
        pageWidthSection?.classList.add('custom-scroll');
      }
      if (buttonContainer && boostSliderContainer) {
        pageWidthSection?.classList.add('custom-scroll');
        buttonContainer.style.display = 'block';
        boostSliderContainer.before(buttonContainer);
      }
    }
    // Focus and move cursor to end for search input if present
    const searchInput = document.getElementById("boost-sd__search-widget-init-input-1");

    // FIXED: Add null check before addEventListener
    if (searchInput) {
      searchInput.addEventListener('focus', e => {
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('overflow-hidden');
      });
    }

    if (document.querySelector(".boost-sd__search-opening") && searchInput) {
      searchInput.addEventListener('focus', e => {
        const { value } = e.target;
        e.target.setSelectionRange(value.length, value.length);
        if (window.innerWidth < 750) {
          setTimeout(() => {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
          }, 10); // Small delay ensures overlay is visible before locking scroll
        }
      });
      searchInput.focus();
    }
  });

  observer.observe(document, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true
  });
});